<template>
  <div class="highlightingChart" ref="chartdiv"></div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_th_TH from "@amcharts/amcharts4/lang/th_TH";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { REFINERY_COLORS } from "@/constant/colors";
import { REFINERY_ID, REFINERY_NAME } from "@/constant";
import { mapState, mapGetters } from "vuex";

export default {
  name: "highlightingChartTransfer",
  data() {
    return {
      chart: null,
      valueAxis: null,
      transferData: [],
      vesselData: [],
    };
  },
  watch: {
    transferLogsByVessel(val) {
      if (val.length > 0) {
        this.setTransferData();
      }
    },
    async vessel(val, oldval) {
      // if (!_.isEqual(val, oldval)) {
      if (val.length > 0) {
        // console.log(val);
        // await this.vesselData.push({vessel_id : val[0].id, vessel_name : val[0].name, member_code : val[0].member_code})
        // this.vesselData = _.uniqBy(this.vesselData, "vessel_id");
      }
    },
  },
  mounted() {
    this.setTransferData();
  },
  computed: {
    ...mapState({
      vessel: (state) => state.mpTankerData.mpVessel,
      transferLogsByVessel: (state) => state.mpVesselData.transferLogsByVessel,
    }),
  },
  created(){
    // this.setTransferData();
  },
  beforeUpdate(){
  //   console.log(this.chartdiv);
  //   console.log("updated",this.transferData);
  },
  methods: {
    async setTransferData() {
      this.transferData = [];
      const setUpData = _.filter(this.transferLogsByVessel, "vessel_id", null);
      // console.log("vessel ",this.vessel);
      await setUpData.map(async(a) => {
        await this.$store.dispatch("getMpVesselById", { vessel_id: a.vessel_id });
        // const vessel_name = _.find(this.vessel, { id:a.vessel_id });
        // const date = new Date(a.start_at);
        // const value = Number(a.volume);
        // return this.transferData.push({date, value, ...vessel_name});
      });
      // console.log(this.vessel);
      this.highlightingChart();
    },
    async highlightingChart() {
      this.transferData = [];

      am4core.useTheme(am4themes_animated);
      const chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      const locale = this.$i18n.locale;
      if (locale == "th") {
        chart.language.locale = am4lang_th_TH;
        chart.numberFormatter.language = new am4core.Language();
        chart.numberFormatter.language.locale = am4lang_th_TH;
        chart.dateFormatter.language = new am4core.Language();
        chart.dateFormatter.language.locale = am4lang_th_TH;
      }

      // this.setTransferData();
      const setUpData = _.filter(this.transferLogsByVessel, "vessel_id", null);
      // console.log("vesselChart",this.vessel);
      await setUpData.map((a) => {
        // console.log(this.vessel,a.vessel_id );
        const vessel_name = _.find(this.vessel, { id:a.vessel_id });
        // console.log(a.vessel_id,vessel_name);
        const date = new Date(a.start_at);
        const value = Number(a.volume);
        return this.transferData.push({date, value, ...vessel_name});
      });
      // console.log("chart", this.transferData);
      chart.data = this.transferData;
      // console.log("chart.data", chart.data);

      // Create chart
      chart.paddingRight = 20;

      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.baseInterval = {
        timeUnit: "minute",
        count: 1,
      };
      dateAxis.tooltipDateFormat = "d MMM , HH:mm";

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.title.text = "ปริมาณน้ำมัน (ลิตร)";

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.dateX = "date";
      series.dataFields.valueY = "value";
      series.dataFields.name = "name";
      series.tooltipText = "{name}: [bold]{valueY}[/]";
      series.fillOpacity = 0.3;

      // Bullets
      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.stroke = am4core.color("#fff");
      bullet.circle.strokeWidth = 1;

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineY.opacity = 0;
    },
  },
};
</script>

<style scoped>
.highlightingChart {
  width: 100%;
  height: 400px;
  max-width: 100%;
}
</style>
